export default {"src":"/_next/static/media/saasgrid.ab750d64.svg","height":22,"width":88,"blurWidth":0,"blurHeight":0};